export const MAX_BANDWIDTH = 2048
export const MIN_BANDWIDTH = 225
export const VIDEO_HEIGHT = 480
export const ASPECT_RATIO = 4 / 3
